// @file Surface Panels store.
import type { PopoverAnchor, PostCustomPropertyValue } from '@@/types'
import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

export const useSurfacePanelsStore = defineStore('surfacePanelsStore', () => {
  // State
  const xSurfaceDetailsPanel = ref(false)
  const xQrModal = ref(false)
  const xSurfaceSharePanel = ref(false)
  const xSurfaceRemakePanel = ref(false)
  const xSurfaceActivityPanel = ref(false)
  const xSurfaceGradingPanel = ref(false)
  const xSurfaceAutomationsPanel = ref(false)
  const xPhotoAlbumImagePicker = ref(false)

  // Phone number field method popover
  const xPhoneFieldMethodPopover = ref(false)
  const phoneFieldMethodPopoverAnchor = ref<PopoverAnchor | null>(null)
  const activePhoneNumberPopoverValue = ref<PostCustomPropertyValue | null>(null)

  function openPhoneNumberPopover({ value, anchor }: { value: PostCustomPropertyValue; anchor: PopoverAnchor }): void {
    activePhoneNumberPopoverValue.value = value
    xPhoneFieldMethodPopover.value = true
    phoneFieldMethodPopoverAnchor.value = anchor
  }

  function closePhoneNumberPopover(): void {
    xPhoneFieldMethodPopover.value = false
    phoneFieldMethodPopoverAnchor.value = null
    activePhoneNumberPopoverValue.value = null
  }

  return {
    // State
    xSurfaceDetailsPanel,
    xQrModal,
    xSurfaceActivityPanel,
    xSurfaceSharePanel,
    xSurfaceGradingPanel,
    xSurfaceRemakePanel,
    xSurfaceAutomationsPanel,
    xPhotoAlbumImagePicker,
    xPhoneFieldMethodPopover,
    phoneFieldMethodPopoverAnchor: readonly(phoneFieldMethodPopoverAnchor),
    activePhoneNumberPopoverValue: readonly(activePhoneNumberPopoverValue),

    // Actions
    openPhoneNumberPopover,
    closePhoneNumberPopover,
  }
})
